import { IonCol } from "@ionic/react";
import classNames from "classnames/bind";
import React from "react";

import styles from "./NewListViewProduct.module.scss";
import { Product } from "@core/types";

const cx = classNames.bind(styles);

interface ProductRatingProps {
  rating: Product["averageRating"];
}

const Rating = ({ rating }: ProductRatingProps) => (
  <IonCol sizeXs="10" className={cx("ion-no-padding")}>
    <div className={cx("stars-outer")}>
      <div className={cx("stars-inner")} style={{ width: `${(parseFloat(rating ?? "0") / 5) * 100}%` }}></div>
    </div>
  </IonCol>
);

export default Rating;
